// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__CfHOF","prefix":"styles_prefix__fCdec","postfix":"styles_postfix__w9bYS"};